import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, message } from 'antd';
import { PhoneOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useApp } from '../../context/AppContext';
import LanguageSwitcher from '../../components/LanguageSwitcher/LanguageSwitcher';
import './Auth.css';

const { Title, Text } = Typography;

const Login = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { login } = useApp();
    const { t, i18n } = useTranslation('auth');
    const isRTL = i18n.language === 'ar' || i18n.language === 'ku';

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const response = await login(values.phone, values.password);
            if (response.success) {
                message.success(t('loginSuccess'));
                const role = response.data?.user?.role;

                // Role-based redirect
                if (role === 'super_admin') {
                    navigate('/superadmin');
                } else if (role === 'receptionist') {
                    navigate('/appointments');
                } else if (role === 'pharmacy') {
                    navigate('/pharmacy');
                } else if (role === 'lab_technician') {
                    navigate('/laboratory');
                } else if (role === 'radiologist') {
                    navigate('/radiology');
                } else {
                    navigate('/dashboard');
                }
            }
        } catch (error) {
            message.error(error.response?.data?.message || t('loginFailed'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container" dir={isRTL ? 'rtl' : 'ltr'}>
            <div style={{ position: 'absolute', top: 16, right: isRTL ? 'auto' : 16, left: isRTL ? 16 : 'auto' }}>
                <LanguageSwitcher />
            </div>
            <Card className="auth-card">
                <div style={{ textAlign: 'center', marginBottom: 32 }}>
                    <Title level={2}>SoftDent</Title>
                    <Text type="secondary">{t('appSubtitle')}</Text>
                </div>

                <Form
                    name="login"
                    onFinish={onFinish}
                    layout="vertical"
                    size="large"
                >
                    <Form.Item
                        name="phone"
                        rules={[
                            { required: true, message: t('phoneRequired') }
                        ]}
                    >
                        <Input
                            prefix={<PhoneOutlined />}
                            placeholder={t('phone')}
                        />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: t('passwordRequired') }]}
                    >
                        <Input.Password
                            prefix={<LockOutlined />}
                            placeholder={t('password')}
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            block
                            loading={loading}
                        >
                            {t('login')}
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default Login;
